import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["PUBLIC_REAL_ESTATE_OWNER"] = "PUBLIC_REAL_ESTATE_OWNER";
    OrganizationType["PRIVATE_REAL_ESTATE_OWNER"] = "PRIVATE_REAL_ESTATE_OWNER";
    OrganizationType["CONTRACTOR"] = "CONTRACTOR";
    OrganizationType["SUBCONTRACTOR"] = "SUBCONTRACTOR";
    OrganizationType["CONSULTANT"] = "CONSULTANT";
})(OrganizationType || (OrganizationType = {}));
export const organizationTypeSchema = z.nativeEnum(OrganizationType);
export var OrganizationRole;
(function (OrganizationRole) {
    OrganizationRole["ADMIN"] = "ADMIN";
    OrganizationRole["USER"] = "USER";
})(OrganizationRole || (OrganizationRole = {}));
export var Services;
(function (Services) {
    Services["TENDER_DOCUMENTS"] = "TENDER_DOCUMENTS";
    Services["OFFER"] = "OFFER";
    Services["TENANT_SPECIFICATION"] = "TENANT_SPECIFICATION";
    Services["TENANT_REQUIREMENTS"] = "TENANT_REQUIREMENTS";
    Services["DUE_DILIGENCE"] = "DUE_DILIGENCE";
    Services["SITE_DUE_DILIGENCE"] = "SITE_DUE_DILIGENCE";
    Services["MANAGEMENT_OPERATIONS_MAINTENANCE"] = "MANAGEMENT_OPERATIONS_MAINTENANCE";
    Services["PLANT_ROOM"] = "PLANT_ROOM";
    Services["CEILING_PLAN"] = "CEILING_PLAN";
    Services["FLOOR_PLAN"] = "FLOOR_PLAN";
    Services["SPACE_ANALYSIS"] = "SPACE_ANALYSIS";
    Services["PARKING"] = "PARKING";
    Services["REPORTS"] = "REPORTS";
    Services["REPORT_GENERATION"] = "REPORT_GENERATION";
    Services["STRUCTURAL"] = "STRUCTURAL";
    Services["CEILING_GRID"] = "CEILING_GRID";
    Services["LOAD_CALCULATION"] = "LOAD_CALCULATION";
    Services["MEETING_SECRETARY"] = "MEETING_SECRETARY";
    Services["SCHEDULE_CHECK"] = "SCHEDULE_CHECK";
    Services["SOLUTION_VIEWER"] = "SOLUTION_VIEWER";
    Services["CONTRACT_REVIEW"] = "CONTRACT_REVIEW";
    Services["LUMINAIRE_SCHEDULE"] = "LUMINAIRE_SCHEDULE";
    Services["RFP_RFQ_REVIEW"] = "RFP_RFQ_REVIEW";
    Services["DESIGN_PACKAGE_REVIEW"] = "DESIGN_PACKAGE_REVIEW";
    Services["QA_AGENT"] = "QA_AGENT";
    Services["CODE_RESEARCH_AGENT"] = "CODE_RESEARCH_AGENT";
    Services["VERSION_COMPARE"] = "VERSION_COMPARE";
    Services["WATER_PROCESS_SYSTEMS_AGENT"] = "WATER_PROCESS_SYSTEMS_AGENT";
    Services["GEOTECHNICAL_EXTRACTION_AGENT"] = "GEOTECHNICAL_EXTRACTION_AGENT";
    Services["ENVIRONMENT_REPORT_AGENT"] = "ENVIRONMENT_REPORT_AGENT";
    Services["LIGHTNING_DESIGNER"] = "LIGHTNING_DESIGNER";
})(Services || (Services = {}));
export const ServicesLabels = {
    [Services.TENDER_DOCUMENTS]: 'Tender Review',
    [Services.OFFER]: 'Bid Review',
    [Services.TENANT_SPECIFICATION]: 'Tenant Specification',
    [Services.TENANT_REQUIREMENTS]: 'Tenant Requirements',
    [Services.DUE_DILIGENCE]: 'Due Diligence',
    [Services.SITE_DUE_DILIGENCE]: 'Site Due Diligence',
    [Services.MANAGEMENT_OPERATIONS_MAINTENANCE]: 'Handover',
    [Services.PLANT_ROOM]: 'Plant Room',
    [Services.CEILING_PLAN]: 'Ceiling Plan',
    [Services.FLOOR_PLAN]: 'Floor Plan',
    [Services.SPACE_ANALYSIS]: 'Space Analysis',
    [Services.PARKING]: 'Parking',
    [Services.REPORTS]: 'Reports',
    [Services.REPORT_GENERATION]: 'Report Generation',
    [Services.STRUCTURAL]: 'Structural',
    [Services.CEILING_GRID]: 'Ceiling Grid',
    [Services.LOAD_CALCULATION]: 'Load Calculation',
    [Services.MEETING_SECRETARY]: 'Meeting Assistant',
    [Services.SCHEDULE_CHECK]: 'Component Reference Checker',
    [Services.SOLUTION_VIEWER]: 'Solution Viewer',
    [Services.CONTRACT_REVIEW]: 'Contract Review',
    [Services.LUMINAIRE_SCHEDULE]: 'Luminaire Schedule',
    [Services.RFP_RFQ_REVIEW]: 'RFP Review',
    [Services.DESIGN_PACKAGE_REVIEW]: 'Design Package Review',
    [Services.QA_AGENT]: 'Model Review Agent',
    [Services.CODE_RESEARCH_AGENT]: 'Code Research Agent',
    [Services.VERSION_COMPARE]: 'Version Compare',
    [Services.WATER_PROCESS_SYSTEMS_AGENT]: 'Water & Process Systems Agent',
    [Services.GEOTECHNICAL_EXTRACTION_AGENT]: 'Geotechnical Extraction Agent',
    [Services.ENVIRONMENT_REPORT_AGENT]: 'Environment Report Agent',
    [Services.LIGHTNING_DESIGNER]: 'Lightning Designer',
};
export const organizationSchema = z
    .object({
    id: z.string().uuid(),
    name: z.string().min(1),
    type: organizationTypeSchema,
    created_at: z.string(),
    available_services: z.array(z.nativeEnum(Services)).optional(),
})
    .strict()
    .transform(mapToCamelCase);
export const createOrganizationRequestSchema = organizationSchema
    .innerType()
    .pick({
    name: true,
    type: true,
    available_services: true,
})
    .strict()
    .transform(mapToCamelCase);
export const getOrganizationsResponseSchema = z.array(organizationSchema).transform(mapToCamelCase);
